import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import { shadowMd } from '../../../../web/styles/shadows';

const { colors, typography } = THEME;
const smallCaps = {
	color: colors.text.light,
	fontSize: typography.fontSizes.xs,
	textTransform: 'uppercase',
} as const;

export const styleSheet = StyleSheet.create({
	container: {
		maxWidth: 1120,
		width: '100%',
	},
	searchBar: {
		margin: `${SPACE[8]}px 0 0`,
		maxWidth: '100%',
		width: 640,
	},
	actionsBar: {
		display: 'flex',
		justifyContent: 'flex-end',
		margin: `${SPACE[24]}px 0 ${SPACE[8]}px`,
	},
	actionsBarCenter: {
		justifyContent: 'flex-start',
	},
	placeholder: {
		display: 'flex',
		justifyContent: 'flex-start',
		marginTop: SPACE[40],
	},
	placeholderCircle: {
		alignItems: 'center',
		background: colors.primary.light,
		borderRadius: '50%',
		display: 'flex',
		height: 320,
		justifyContent: 'center',
		width: 320,
	},
	placeholderImage: {
		width: 270,
	},
	numbersContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[32],
		padding: `${SPACE[20]}px 0`,
	},
	card: {
		alignItems: 'center',
		background: colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowMd,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		gap: SPACE[16],
		minHeight: 90,
		padding: SPACE[20],
		position: 'relative',
		width: '100%',
	},
	newPill: {
		left: 0,
		position: 'absolute',
		top: 0,
	},
	loadingRow: {
		alignItems: 'center',
		display: 'flex',
		height: 24,
		justifyContent: 'center',
		width: '100%',
	},
	toggleCell: {
		display: 'flex',
		flexShrink: 0,
		width: SPACE[28],
	},
	numberCell: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		fontWeight: typography.fontWeights.bold,
		gap: SPACE[4],
		width: 190,
	},
	callingCell: {
		flexShrink: 0,
		whiteSpace: 'nowrap',
		width: 140,
	},
	connectionCell: {
		flexShrink: 0,
		width: 100,
	},
	dateCell: {
		...smallCaps,
		flexShrink: 0,
		width: 200,
	},
	providerCell: {
		...smallCaps,
		flex: 1,
		minWidth: 0,
		overflowWrap: 'anywhere',
	},
	releaseCell: {
		display: 'flex',
		flexShrink: 0,
		justifyContent: 'flex-end',
		minWidth: 80,
	},
	spinnerRow: {
		display: 'flex',
		justifyContent: 'center',
	},
	prompt: {
		background: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		bottom: SPACE[24],
		boxShadow: shadowMd,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		fontSize: typography.fontSizes.sm,
		gap: SPACE[8],
		left: SPACE[24],
		padding: SPACE[16],
		position: 'fixed',
		width: 300,
		zIndex: 10,
	},
	promptHeader: {
		alignItems: 'flex-start',
		display: 'flex',
		justifyContent: 'space-between',
	},
	promptLines: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
	},
	promptActions: {
		display: 'flex',
		gap: SPACE[8],
	},
});
